import React, { useState, useEffect } from "react";
import { Android12Switch, StyledButton, StyledBox, StyledTypo, StyledPaper, StyledCarousel, StyledDialog } from "../StyledMui";
import { Grid, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, FormControlLabel, Chip, Card, CardContent, CardMedia, Button, Typography, Avatar, Stack, Box, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import useStore from "../Store";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";

function Preview(props) {
  const { isVar, setIsVar, variabledContent, setVariabledContent, variabledContents, setVariabledContents, open, setOpen, page, setPage, variableSwitchFlag, setVariableSwitchFlag, phoneMessageSwitchFlag, setPhoneMessageSwitchFlag } = useStore((state) => state.preview);
  const { templates, selectedTemplate, setSelectedTemplate, selectedChannelName, journeyType } = useStore((state) => state.header);
  const { contacts, getContacts, datas } = useStore((state) => state.mapper);

  useEffect(() => {
    console.log("change contacts : ", isVar);
  }, [contacts]);

  useEffect(() => {}, [page]);

  const handleVariabled = async (sw, isPhoneMessage) => {
    setIsVar(sw);
    if (sw === true) {
      if (contacts.length === 0) {
        await getContacts();
      } else {
        setPage(0);
        //setVariabledContents(contacts.map((contact) => setVariables(contact, isPhoneMessage)));
      }
    }
    //setOpen(false);
  };

  const setVariables = (contact, isPhoneMessage, text) => {
    let result =
      isPhoneMessage === true && selectedTemplate.mmsAttach
        ? JSON.parse(selectedTemplate.mmsAttach)?.mmsContent || ""
        : /*selectedTemplate.templateMessageType === 'FL' ? [1,2,3,4].map(el => {'header' : selectedTemplate[`carouselHeader${c}`, 'message' : selectedTemplate[`carouselHeader${c}`}]) :
    selectedTemplate.templateMessageType === 'FC'? [1,2,3,4,5,6].map(el => {'header' : selectedTemplate[`carouselHeader${c}`, 'message' : selectedTemplate[`carouselHeader${c}`}]):
    : selectedTemplate.templateContent*/ text;
    //console.log('setVariables!! ',datas)
    if (contact && text) {
      text.match(/(?<=#\{)(.*?)(?=\})/g)?.map((v) => {
        datas
          .filter((d) => d.name === v)
          .map((el) => {
            //console.log(el, contact)
            let val = el.value.toLowerCase(),
              str = el.type === "field" ? (el.value === "Contact Name" ? contact["contact last name"] + contact["contact first name"] : el.value === "SalesRep Name" ? contact["salesrep last name"] + contact["salesrep first name"] : el.value === "Name" ? contact["last name"] + contact["first name"] : contact[val]) : el.value;
            result = result.replaceAll(`#{${el.name}}`, `#{${str}}`);
          });
      });
    }
    //console.log(result)
    return result;
  };

  const useHighlightedContent = (content, variabled) => {
    const regex = /(#{.*?})/g;
    const parts = content?.split(regex);
    //console.log(parts)
    const parsedContent = parts?.map((part, index) => {
      if (part.startsWith("#{") && part.endsWith("}")) {
        return (
          <span style={{ backgroundColor: "yellow" }} key={index}>
            {variabled === true ? part.replace(/[#\\{\\}]/gi, "") : part}
          </span>
        );
      } else {
        return part;
      }
    });

    return parsedContent;
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "left", marginLeft: "50px", marginRight: "50px" }}>
      <Card sx={{ maxWidth: 350, width: "100%" }}>
        {!phoneMessageSwitchFlag && selectedTemplate.templateMessageType === "FC" ? (
          <StyledCarousel swipeable={true} showThumbs={false} dynamicHeight={false} showStatus={false}>
            {[...Array(6).keys()]
              .filter((index) => {
                const headerKey = `carouselHeader${index + 1}`;
                return selectedTemplate[headerKey] !== null && selectedTemplate[headerKey] !== undefined;
              })
              .map((index) => {
                const headerKey = `carouselHeader${index + 1}`;
                const messageKey = `carouselMessage${index + 1}`;
                return (
                  <>
                    <CardMedia component="img" height="auto" image={!phoneMessageSwitchFlag && selectedTemplate.templateImageUrl && JSON.parse(selectedTemplate?.templateImageUrl)[index]} />
                    <Stack direction="column" spacing={1} key={index}>
                      <Typography variant="subtitle1" fontWeight="bold" sx={{ margin: "10px !important", textAlign: "left" }}>
                        {useHighlightedContent(isVar === true ? setVariables(contacts[page], phoneMessageSwitchFlag, selectedTemplate[headerKey]) : selectedTemplate[headerKey], isVar)}
                      </Typography>
                      <Divider sx={{ marginLeft: "15px", marginRight: "15px" }} />
                      {/*2024 09 17 장은: 수정. , whiteSpace: "pre-line" 추가하여 줄바꿈 반영함. */}
                      <Typography variant="body2" sx={{ textAlign: "left", margin: "10px !important", whiteSpace: "pre-line" }}>
                        {useHighlightedContent(isVar === true ? setVariables(contacts[page], phoneMessageSwitchFlag, selectedTemplate[messageKey]) : selectedTemplate[messageKey], isVar)}
                      </Typography>
                      <Stack direction="row" spacing={0.5} alignItems="center" sx={{ margin: "8px !important", justifyContent: "center" }}>
                        {selectedTemplate.buttons &&
                          JSON.parse(selectedTemplate.buttons)[index]?.map((button, buttonIndex) => (
                            <Button
                              key={buttonIndex}
                              variant="contained"
                              fullWidth
                              sx={{
                                backgroundColor: "#6c757d",
                                "&:hover": {
                                  backgroundColor: "#343a40",
                                },
                              }}>
                              {button.name}
                            </Button>
                          ))}
                      </Stack>
                    </Stack>
                  </>
                );
              })}
          </StyledCarousel>
        ) : !phoneMessageSwitchFlag && selectedTemplate.templateMessageType === "FL" ? (
          <CardContent>
            <Typography variant="body1" sx={{ fontWeight: "bold", margin: "10px", textAlign: "center" }}>
              {useHighlightedContent(isVar === true ? setVariables(contacts[page], phoneMessageSwitchFlag, selectedTemplate.itemListHeader) : selectedTemplate.itemListHeader, isVar)}
            </Typography>
            <Box sx={{ position: "relative", maxWidth: 300, height: 120, margin: "auto", display: "block" }}>
              <CardMedia component="img" sx={{ width: "100%", height: "100%" }} image={selectedTemplate.templateImageUrl && JSON.parse(selectedTemplate?.templateImageUrl)[0]} />
              <Typography variant="body2" sx={{ position: "absolute", bottom: 0, left: 0, color: "white", padding: "2px", textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)" }}>
                {useHighlightedContent(isVar === true ? setVariables(contacts[page], phoneMessageSwitchFlag, selectedTemplate.itemListTitle1) : selectedTemplate.itemListTitle1, isVar)}
              </Typography>
            </Box>

            <Stack direction="column" spacing={1}>
              <Grid container spacing={1}></Grid>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={2}>
                  <CardMedia component="img" height="60" image={selectedTemplate.templateImageUrl && JSON.parse(selectedTemplate?.templateImageUrl)[1]} />
                </Grid>
                <Grid item xs={10}>
                  <Typography variant="body2">{useHighlightedContent(isVar === true ? setVariables(contacts[page], phoneMessageSwitchFlag, selectedTemplate.itemListTitle2) : selectedTemplate.itemListTitle2, isVar)}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={2}>
                  <CardMedia component="img" height="60" image={selectedTemplate.templateImageUrl && JSON.parse(selectedTemplate?.templateImageUrl)[2]} />
                </Grid>
                <Grid item xs={10}>
                  <Typography variant="body2">{useHighlightedContent(isVar === true ? setVariables(contacts[page], phoneMessageSwitchFlag, selectedTemplate.itemListTitle3) : selectedTemplate.itemListTitle3, isVar)}</Typography>
                </Grid>
              </Grid>
              {selectedTemplate.itemListTitle4 && (
                <Grid container spacing={1} alignItems="center">
                  <Grid item xs={2}>
                    <CardMedia component="img" height="60" image={selectedTemplate.templateImageUrl && JSON.parse(selectedTemplate?.templateImageUrl)[3]} />
                  </Grid>
                  <Grid item xs={10}>
                    <Typography variant="body2">{useHighlightedContent(isVar === true ? setVariables(contacts[page], phoneMessageSwitchFlag, selectedTemplate.itemListTitle4) : selectedTemplate.itemListTitle4, isVar)}</Typography>
                  </Grid>
                </Grid>
              )}
            </Stack>
          </CardContent>
        ) : (
          <>
            {!phoneMessageSwitchFlag && selectedTemplate.templateImageUrl && <CardMedia component="img" height="auto" image={JSON.parse(selectedTemplate.templateImageUrl)[0]} />}
            <CardContent>
              {!phoneMessageSwitchFlag && selectedTemplate.templateEmphasizeType === "TEXT" && (
                <>
                  <Typography sx={{ textAlign: "left", color: "text.secondary" }} variant="body2">
                    {selectedTemplate.templateSubtitle}
                  </Typography>
                  <Typography sx={{ textAlign: "left", fontWeight: "bold" }} variant="h6">
                    {selectedTemplate.templateTitle}
                  </Typography>
                  <Divider sx={{ marginLeft: "8px", marginRight: "8px", marginBottom: "10px", marginTop: "10px" }} />
                </>
              )}

              {phoneMessageSwitchFlag && selectedTemplate.mmsAttach && (
                <Typography
                  sx={{
                    textAlign: "left",
                    wordWrap: "break-word",
                    whiteSpace: "pre-wrap",
                    fontWeight: "bold",
                  }}
                  variant="h6"
                  color="text.secondary">
                  {JSON.parse(selectedTemplate.mmsAttach).subject}
                </Typography>
              )}
              <Typography sx={{ textAlign: "left", wordWrap: "break-word", whiteSpace: "pre-wrap" }} variant="body2" color="text.secondary">
                {useHighlightedContent(isVar === true ? setVariables(contacts[page], phoneMessageSwitchFlag, selectedTemplate.templateContent) : selectedTemplate.templateContent, isVar)}
              </Typography>
              {!phoneMessageSwitchFlag && (selectedTemplate.templateMessageType === "EX" || selectedTemplate.templateMessageType === "MI") && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: "10px",
                    fontSize: "12px",
                    wordWrap: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                  variant="body2"
                  color="text.secondary">
                  {selectedTemplate.templateExtra}
                </Typography>
              )}
            </CardContent>
          </>
        )}

        {!phoneMessageSwitchFlag && selectedTemplate.templateMessageType !== "FC" && (
          <Stack spacing={0.5} sx={{ margin: "10px" }}>
            {(selectedTemplate.templateMessageType === "AD" || selectedTemplate.templateMessageType === "MI") && (
              <Typography sx={{ textAlign: "left", marginBottom: "5px" }} variant="body2" color="text.secondary">
                채널 추가하고 이 채널의 광고와 마케팅 메시지를 카카오톡으로 받기
              </Typography>
            )}

            {selectedTemplate.templateMessageType === "FL" ? (
              <Stack direction="row" spacing={0.5} alignItems="center">
                {selectedTemplate.buttons &&
                  JSON.parse(selectedTemplate.buttons)[0]?.map((button, index) => (
                    <Button
                      key={index}
                      variant="contained"
                      fullWidth
                      sx={{
                        backgroundColor: "#6c757d",
                        "&:hover": {
                          backgroundColor: "#343a40",
                        },
                      }}>
                      {button.name}
                    </Button>
                  ))}
              </Stack>
            ) : (
              !phoneMessageSwitchFlag &&
              selectedTemplate.buttons &&
              JSON.parse(selectedTemplate.buttons)[0]?.map((button, index) => (
                <Button
                  key={index}
                  variant="contained"
                  fullWidth
                  sx={{
                    backgroundColor: "#6c757d",
                    "&:hover": {
                      backgroundColor: "#343a40",
                    },
                  }}>
                  {button.name}
                </Button>
              ))
            )}
          </Stack>
        )}
      </Card>
      <Box sx={{ maxWidth: 350, display: "flex", flexWrap: "nowrap" }}>
        <Stack spacing={0.5} sx={{ marginTop: "10px" }} direction="row">
          {!phoneMessageSwitchFlag &&
            selectedTemplate &&
            selectedTemplate.quickReplies &&
            JSON.parse(selectedTemplate.quickReplies)?.map((quickLink, index) => (
              <Chip
                label={quickLink.name}
                key={index}
                sx={{
                  backgroundColor: "#f1f1f1",
                  color: "#191919",
                  whiteSpace: "nowrap",
                  minWidth: "0",
                  "&:hover": {
                    backgroundColor: "#cccccc",
                  },
                }}></Chip>
            ))}
        </Stack>
      </Box>
    </Box>
  );
}

export default Preview;
